import {
    MESSAGE_TEMPLATES_ENDPOINT,
    MESSAGE_TEMPLATE_BY_ID_ENDPOINT,
    MESSAGE_TEMPLATE_TOGGLE_ENDPOINT
} from "../api-services/ApiEndpoints";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getAllTemplates = async () => {
    const url = `${process.env.REACT_APP_API_URL}${MESSAGE_TEMPLATES_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch templates: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get templates error:', error);
        throw error;
    }
};

export const getTemplateById = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${MESSAGE_TEMPLATE_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch template: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get template error:', error);
        throw error;
    }
};

export const createTemplate = async (templateData) => {
    const url = `${process.env.REACT_APP_API_URL}${MESSAGE_TEMPLATES_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(templateData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to create template: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Create template error:', error);
        throw error;
    }
};

export const updateTemplate = async (id, templateData) => {
    const url = `${process.env.REACT_APP_API_URL}${MESSAGE_TEMPLATE_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(templateData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to update template: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Update template error:', error);
        throw error;
    }
};

export const toggleTemplate = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${MESSAGE_TEMPLATE_TOGGLE_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to toggle template: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Toggle template error:', error);
        throw error;
    }
};

export const deleteTemplate = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${MESSAGE_TEMPLATE_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to delete template: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Delete template error:', error);
        throw error;
    }
};
